import { BrowserRouter } from 'react-router-dom';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material';
import Box from '@mui/material/Box';
import Navigation from './components/navigation/Navigation';
import Header from './components/elements/Header/Header';
import Footer from './components/elements/Footer/Footer';
import './App.css';
import WebSocketInitializer from './WebSocketInitializer';
import RestoreStatus from './RestoreStatus';
import ChatWidget from './components/elements/Сhat/ChatWidget';
import theme from './theme/theme';
import { ChatTabsProvider } from './contexts/ChatTabsContext';
import { ClearChatsHandler } from './utils/Chat/handleClearChats';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ChatTabsProvider>
          <WebSocketInitializer />
          <RestoreStatus />
          <div className="container-page">
            <Header />
            <main>
              <Container maxWidth="lg" disableGutters>
                <Box>
                  <Navigation />
                </Box>
              </Container>
            </main>
            <Footer />
            <ChatWidget />
          </div>
          <ClearChatsHandler />
        </ChatTabsProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
export default App;
